import React from 'react'

import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

import FieldMessage from 'components/Form/components/Field/FieldMessage'
import IconPicker from 'components/Form/components/IconPicker'
import Skeleton from 'components/Form/components/Skeleton/styled'
import ValuePicker from 'components/Form/components/ValuePicker'
import IconPickerFieldStyled from 'components/Form/fields/IconPickerField/styled'
import Icon from 'components/Global/Icon'

const IconPickerField = ({
  children,
  name,
  options,
  defaultValue,
  value = true,
  disabled,
  validation,
  disableClick,
  size,
  onChange,
  label,
  fullWidth,
  selectionKeys,
  allowClear = false,
  dropdownRender,
  optionComponent,
  filters,
  open,
  width,
  showRequired,
  ...props
}) => {
  return (
    <IconPickerFieldStyled {...props} label={label} required={showRequired && validation?.required}>
      {({ control, errors, isEditMode, loading }) => {
        if (!name) {
          return (
            <IconPicker
              {...{
                value,
                options,
                onChange,
                fullWidth,
                dropdownRender,
                selectionKeys,
                open,
                optionComponent,
                filters,
                width,
              }}
              search
            />
          )
        }

        const error = get(errors, name)
        return (
          <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            rules={validation}
            render={({ onChange: fromFieldOnChange, value: formFieldValue }) => {
              if (loading) {
                return <Skeleton width="200px" />
              }

              if (isEditMode) {
                return (
                  <>
                    <IconPicker
                      value={formFieldValue}
                      onChange={(value, itemObject) => {
                        fromFieldOnChange(value)
                        if (typeof onChange === 'function') {
                          onChange(value, itemObject)
                        }
                      }}
                      search
                      {...{
                        options,
                        disabled,
                        error,
                        fullWidth,
                        dropdownRender,
                        selectionKeys,
                        allowClear,
                        open,
                        optionComponent,
                        filters,
                        width,
                      }}
                    />
                    <FieldMessage message={error} label={label} />
                  </>
                )
              }

              return <Icon icon={formFieldValue} />
            }}
          />
        )
      }}
    </IconPickerFieldStyled>
  )
}

ValuePicker.propTypes = {
  fullWidth: PropTypes.bool,
  allowClear: PropTypes.bool,
}

export default IconPickerField
